import { TreeDataProvider } from './TreeDataProvider'
import TreeViewContainer from './TreeViewContainer'

TreeViewWrapper = ->
  <TreeDataProvider>
    <TreeViewContainer />
  </TreeDataProvider>

export default TreeViewWrapper
